/*
 * @Description:
 * @Date: 2024-11-29 11:37:12
 */
import { WHITE_LIST } from '@constants/intercept';

export default async (to, next) => {
  // 白名单或单独启动调试，可以直接进入页面
  if (
    WHITE_LIST.includes(to.path) ||
    (to.meta.isIndependent && process.env.NODE_ENV === 'development')
  ) {
    next();
    return Promise.reject();
  }
  return Promise.resolve();
};
